import { jsx as _jsx } from "react/jsx-runtime";
import DivResizer from './DivResizer';
import SVGResizer from './SVGResizer';
export default function Resizer(props) {
    const { tag = 'div', ...resProps } = props;
    if (tag === 'div') {
        return _jsx(DivResizer, { ...resProps });
    }
    else {
        return _jsx(SVGResizer, { ...resProps });
    }
}
